import styled from 'styled-components'

export const SidebarWrapper = styled.aside`
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 256px;
  background: var(--vo-escuro);
  z-index: 120;
  display: flex;
  flex-direction: column;
  transition: width 200ms cubic-bezier(.4,0,.2,1);
  overflow: hidden;

  &.menu-close {
    width: 64px;
  }

  @media (width <= 1200px) {
    transform: translateX(-110%);
    transition: transform 200ms cubic-bezier(.4,0,.2,1);
    &.menu-open {
      transform: translateX(0);
    }
  }

  ::-webkit-scrollbar { width: 4px; }
  ::-webkit-scrollbar-track { background: transparent; }
  ::-webkit-scrollbar-thumb {
    background: color-mix(in srgb, var(--vo-capri) 30%, transparent);
    border-radius: 3px;
  }
`

export const LogoArea = styled.div`
  padding: 14px 16px;
  border-bottom: 1px solid color-mix(in srgb, var(--vo-white) 7%, transparent);
  min-height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  gap: 8px;
  overflow: hidden;
`

export const LogoInitialsAvatar = styled.div`
  width: 28px;
  height: 28px;
  min-width: 28px;
  border-radius: 7px;
  background: color-mix(in srgb, var(--vo-capri) 20%, transparent);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Rubik', sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: var(--vo-capri);
`

export const LogoTenantName = styled.span`
  font-family: 'Rubik', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const NavScroll = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px 0;
`

export const NavItem = styled.div`
  display: flex;
  align-items: center;
  min-height: 44px;
  cursor: pointer;
  font-family: 'Maven Pro', sans-serif;
  font-size: 14px;
  user-select: none;
  transition: background 150ms ease, color 150ms ease;

  gap: ${({ $collapsed }) => $collapsed ? 0 : '10px'};
  padding: ${({ $collapsed }) => $collapsed ? '0' : '0 14px 0 16px'};
  justify-content: ${({ $collapsed }) => $collapsed ? 'center' : 'flex-start'};
  border-left: ${({ $collapsed, $active }) =>
    $collapsed ? 'none' : $active ? '3px solid var(--vo-capri)' : '3px solid transparent'};
  background: ${({ $active }) => $active ? 'color-mix(in srgb, var(--vo-capri) 12%, transparent)' : 'transparent'};
  color: ${({ $collapsed, $active }) =>
    $active ? 'var(--vo-capri)' : $collapsed ? 'color-mix(in srgb, var(--vo-white) 55%, transparent)' : 'color-mix(in srgb, var(--vo-white) 82%, transparent)'};
  font-weight: ${({ $active }) => $active ? 600 : 400};

  &:hover {
    background: ${({ $active }) => $active ? 'color-mix(in srgb, var(--vo-capri) 12%, transparent)' : 'color-mix(in srgb, var(--vo-white) 7%, transparent)'};
  }
`

export const NavItemLabel = styled.span`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const NavChevron = styled.span`
  margin-left: auto;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  opacity: 0.5;
  transition: transform 200ms ease;
  transform: ${({ $open }) => $open ? 'rotate(180deg)' : 'rotate(0deg)'};
`

export const NavBadge = styled.span`
  background: var(--vo-danger);
  color: white;
  font-size: 10px;
  font-family: 'Maven Pro', sans-serif;
  font-weight: 700;
  padding: 1px 6px;
  border-radius: 10px;
  flex-shrink: 0;
`

export const NavIconWrapper = styled.span`
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
`

export const NavBadgeDot = styled.span`
  position: absolute;
  top: -6px;
  right: -8px;
  min-width: 15px;
  height: 15px;
  padding: 0 3px;
  border-radius: 8px;
  background: var(--vo-danger);
  border: 2px solid var(--vo-escuro);
  color: white;
  font-size: 9px;
  font-family: 'Maven Pro', sans-serif;
  font-weight: 700;
  line-height: 11px;
  text-align: center;
  box-sizing: border-box;
`

export const SubMenu = styled.div`
  background: color-mix(in srgb, var(--vo-escuro) 15%, transparent);
  overflow: hidden;
`

export const SubItem = styled.a`
  display: block;
  padding: 9px 16px 9px 46px;
  font-family: 'Maven Pro', sans-serif;
  font-size: 13px;
  font-weight: ${({ $active }) => $active ? 600 : 400};
  color: ${({ $active }) => $active ? 'var(--vo-capri)' : 'color-mix(in srgb, var(--vo-white) 62%, transparent)'};
  background: ${({ $active }) => $active ? 'color-mix(in srgb, var(--vo-capri) 8%, transparent)' : 'transparent'};
  text-decoration: none;
  cursor: pointer;
  transition: background 150ms ease, color 150ms ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    background: color-mix(in srgb, var(--vo-white) 5%, transparent);
    color: color-mix(in srgb, var(--vo-white) 82%, transparent);
  }
`

export const SidebarDivider = styled.div`
  height: 1px;
  background: color-mix(in srgb, var(--vo-white) 8%, transparent);
  margin: 8px 0;
`

export const BottomSection = styled.div`
  border-top: 1px solid color-mix(in srgb, var(--vo-white) 7%, transparent);
  padding: 8px 0;
  flex-shrink: 0;
`
